<template>
  <div class="msg_box clearfloat">
    <div class="reg_left">
      <img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/register.png" />
    </div>
    <div class="reg_right">
      <p class="tech_title">注册新账号</p>
      <div class="reg_inpt">
        <div class="reg_name">用户名:<span>*</span></div>
        <input v-model="ruleForm.nickname" />
      </div>
      <div class="reg_inpt">
        <div class="reg_name">手机号:<span>*</span></div>
        <input class="ma-top10" v-model="ruleForm.phone" />
        <button v-if="isyzm" @click="setyzm" class="reg_btn">发送验证码</button>
		<div v-else class="reg_number">{{yzmnumber}}秒后重试</div>
      </div>
      <div class="reg_inpt">
        <div class="reg_name">手机验证码:<span>*</span></div>
        <input v-model="ruleForm.code" />
      </div>
      <div class="reg_inpt">
        <div class="reg_name">密码:<span>*</span></div>
        <input v-model="ruleForm.password" type="password" />
      </div>
      <div class="reg_inpt">
        <div class="reg_name">确认密码:<span>*</span></div>
        <input v-model="ruleForm.repassword" type="password" />
      </div>
      <div class="reg_inpt">
        <div class="reg_name">验证码:<span>*</span></div>
        <input class="ma-top10" v-model="ruleForm.yzm" />
        <!-- <div >56673</div> -->
        <canvas id="canvas" ref="yzm"  @click="draw()" class="reg_yzm"></canvas>
      </div>
      <div class="reg_box">
        <el-checkbox style="color: #444444" v-model="checked" >我已看过并接受<span class="user_fo" @click.stop="xin.goUrl('/userAgreement')">《注册协议》</span></el-checkbox >
        <button v-notClick="isTo" class="laing_btn" @click="Postregistered">注册</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations,mapActions} from "vuex";
export default {
  data() {
    return {
		isTo:true,
		isyzm:true,
		yzmnumber:60,
    checked: false, //请先同意服务条款
	  timeId: -1, //是否关注公众号定时器
	  timeYzm:-1,//验证码定时器
	  yzms:'',
      ruleForm: {
        nickname: "",
        phone: "",
        code: "",
        password: "",
        repassword: "",
        yzm: "",
      },
    };
  },
  mounted() {
    this.draw();
  },
  methods: {
	  ...mapMutations(["settoken"]),
	...mapActions(['getUser']),
	  async setyzm(){//获取手机验证码
	  if (!this.ruleForm.phone) {
      this.$message({ message: "请输入手机号", type: "warning" });
      return;
    }
      this.isyzm = false;
      this.yzmnumber = 60;
      let res = await this.api.PostphoneYzm({type:4,phone:this.ruleForm.phone});
		//倒计时
		this.timeYzm = setInterval(()=>{
			this.yzmnumber--;
			if(this.yzmnumber<0){
				this.isyzm = true;
				clearTimeout(this.timeYzm);
			}
		},1000);
	  },
    async Postregistered() {//注册
      let ruleForm = this.ruleForm;
      if (!this.checked) {
        this.$message.error("请先同意服务条款");
      } else if (!ruleForm.nickname) {
        this.$message({ message: "请输入用户名", type: "warning" });
      } else if (!ruleForm.phone) {
        this.$message({ message: "请输入手机号", type: "warning" });
      } else if (!ruleForm.code) {
        this.$message({ message: "请输入手机验证码", type: "warning" });
      } else if (!ruleForm.password) {
        this.$message({ message: "请输入密码", type: "warning" });
      } else if (!ruleForm.repassword) {
        this.$message({ message: "请输入确认密码", type: "warning" });
      } else if (ruleForm.repassword != ruleForm.password) {
        this.$message({ message: "两次密码不一致", type: "warning" });
      } else if (!ruleForm.yzm) {
        this.$message({ message: "请输入验证码", type: "warning" });
      } else if (ruleForm.yzm.toLowerCase() != this.yzms.toLowerCase()) {
		this.draw();
		this.$message({ message: "验证码错误", type: "warning" });
		this.ruleForm.yzm = '';
	  } else{
		// return;
		this.isTo = false;
		let msg = await this.api.Postregistered(this.ruleForm);
		if(msg.code==200){
			this.settoken(msg.data.token);
			this.getUser();
			this.$router.push({ name: '注册二维码',params: { key7:msg.data.key,val:'QWE' }})
		}else {
      this.draw();
      this.ruleForm.yzm = '';
    }
		this.isTo = true;
      }
      // xin.goUrl({path:'/'})
    },
    draw() {
      //生成并渲染出验证码图形 this.$refs.yzm.style.width
	  let show_num = [];
	  this.yzms = '';
      var canvas_width = 120;
      var canvas_height = 40;
      var canvas = this.$refs.yzm; //获取到canvas的对象，演员
      var context = canvas.getContext("2d"); //获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      var sCode =  "a,b,c,d,e,f,g,h,i,j,k,m,n,p,q,r,s,t,u,v,w,x,y,z,A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
      var aCode = sCode.split(",");
      var aLength = aCode.length; //获取到数组的长度
      for (var i = 0; i < 4; i++) {
        //这里的for循环可以控制验证码位数（如果想显示6位数，4改成6即可）
        var j = Math.floor(Math.random() * aLength); //获取到随机的索引值
        // var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
        var deg = Math.random() - 0.5; //产生一个随机弧度
        var txt = aCode[j]; //得到随机的一个内容
		    this.yzms = this.yzms+txt;
        show_num[i] = txt;
        var x = 10 + i * 20; //文字在canvas上的x坐标
        var y = 20 + Math.random() * 8; //文字在canvas上的y坐标
        context.font = "700 20px Arial";
        context.translate(x, y);
        context.rotate(deg);
        context.fillStyle = this.randomColor(50,160);
        context.fillText(txt, 0, 0);
        context.rotate(-deg);
        context.translate(-x, -y);
	  }
		
	//  
      for (var i = 0; i <= 5; i++) {
        //验证码上显示线条
        context.strokeStyle = this.randomColor(40,180);
        context.beginPath();
        context.moveTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.lineTo(
          Math.random() * canvas_width,
          Math.random() * canvas_height
        );
        context.stroke();
      }
      for (var i = 0; i <= 30; i++) {
        //验证码上显示小点
        context.strokeStyle = this.randomColor(0,255);
        context.beginPath();
        var x = Math.random() * canvas_width;
        var y = Math.random() * canvas_height;
        context.moveTo(x, y);
        context.lineTo(x + 1, y + 1);
        context.stroke();
      }
    },
    randomNum(min,max){
      return Math.floor( Math.random()*(max-min)+min);
    },
    randomColor(min,max) {
      //得到随机的颜色值
      var r = this.randomNum(min,max);
      var g = this.randomNum(min,max);
      var b = this.randomNum(min,max);
      return "rgb("+r+","+g+","+b+")";
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.reg_right {
  float: right;
  width: 550px;

  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #444444;
  }
  .user_fo {
    font-size: 16px;
    font-weight: 400;
    color: #013ba3;
    cursor: pointer;
  }
  .reg_box {
    margin-top: 70px;
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 76px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f2f2f2;
    .laing_btn {
      width: 110px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      margin-left: 20px;
    }
  }
  .reg_inpt {
    color: #444444;
    border-bottom: 1px solid #dedede;
    display: flex;
    margin-top: 40px;
    .reg_btn {
      border: 1px solid #005699;
      border-radius: 20px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #005699;
      cursor: pointer;
    }
    .reg_yzm {
      width: 130px;
      height: 40px;
      cursor: pointer;
    }
    .reg_name {
      padding-bottom: 10px;
      width: 120px;

      span {
        color: #af302f;
      }
    }
    input {
      width: 300px;
      height: 30px;
      background: none;
      outline: none;
      border: none;
      font-size: 20px;
      margin-bottom: -5px;
    }
    input:focus {
      border: none;
    }
  }
}
.msg_box {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reg_left {
  img {
    width: 600px;
  }
}
</style>
